module.exports = __webpack_public_path__ + "media/images/pic/hero/brodno-d319aedd75cab69295f1aed516c6a60e.png";